import { render, staticRenderFns } from "./AppItemDetailsDetails.vue?vue&type=template&id=38506592&scoped=true&"
import script from "./AppItemDetailsDetails.vue?vue&type=script&lang=ts&"
export * from "./AppItemDetailsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AppItemDetailsDetails.vue?vue&type=style&index=0&id=38506592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38506592",
  null
  
)

export default component.exports